module.exports = __webpack_public_path__ + "img/passcode.36d6803c.svg";